import { useMemo } from 'react';
import { useSetState } from 'react-use';
import { useAppSelector } from '@redux/store';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { CElement, CLocation, CView, IConfigComponent } from '@ts/ui-models';
import { useNavigate } from 'react-router';
import {
  Button,
  Typography,
  Icon,
  generateEntityColumn,
  TInheritedProps,
  IDataGridConfig,
  generateComponentColumn,
} from '@ts/storybook';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';

interface IViewProps {
  quickFindInit?: () => any;
  inheritedProps?: TInheritedProps<false>;
  configComponent?: IConfigComponent;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'views',
  aclId: 'taView',
  entity: 'view',
  fetchURL: '/api/views',
  crudURL: '/api/view',
  mainClass: CView,
};

const Views = (props: IViewProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    //columnVisibilityModel: { id: false },
    widthColumns: { name: 300, location: 300, GoToMap: 400 },
  };

  const navigate = useNavigate();
  const settings = useAppSelector(state => state.global.settings);
  const defaultViewId = settings?.defaultView?.defaultViewId;

  //#region Functions
  const onShowMap = (event, args: any) => {
    const routeNavigateMap = `/view/${args.logicalId}/map`;
    const routeQuery = `?title=${args.name}&routeLastBread=/view/${args.logicalId}/edit`;

    if (event.ctrlKey || event.metaKey) {
      window.open(routeNavigateMap + routeQuery, '_blank');
      event.preventDefault();
      return;
    }
    if (!(event.ctrlKey || event.metaKey)) {
      event.preventDefault();

      return navigate(routeNavigateMap, {
        state: { title: args.name, routeLastBread: `/view/${args.logicalId}/edit` },
      });
    }
  };
  //#endregion

  const getColumns: GridColDef<any>[] = useMemo(
    () => [
      {
        headerName: 'ID',
        field: 'id',
        hideable: true,
      },
      {
        headerName: 'Name',
        field: 'name',
        renderCell: (params: GridRenderCellParams) => {
          const tElement = new CElement(params.row);
          const isDefault = defaultViewId === tElement.getID();
          return (
            <Typography variant="body2">
              {tElement.name} {isDefault && <b>{' (' + 'default' + ')'}</b>}
            </Typography>
          );
        },
      },
      generateEntityColumn({ field: 'location' }, { tEntity: 'location', mainClass: CLocation }, { inheritedProps }),
      generateComponentColumn(
        (params: GridRenderCellParams) => (
          <Button
            fullWidth
            disabled={props.inheritedProps?.isEntitySelector}
            label={['Go to', ' ', params.row?.viewType?.name]}
            endIcon={<Icon icon="maps-map" color="primary" />}
            onClick={e => onShowMap(e, params.row)}
            variant="outlined"
            component="a"
            href={
              `/view/${params.row.logicalId}/map?title=${params.row.name}&routeLastBread=/view/${params.row.logicalId}/edit` ||
              '#'
            }
            rel="noopener noreferrer"
          />
        ),
        { field: 'GoToMap', headerName: '' },
        { field: 'myself' }
      ),
    ],
    [defaultViewId]
  );

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      dataGridMode={'server'}
      //From grandpa
      inheritedProps={props.inheritedProps}
    />
  );
};

export default Views;
